import { createContext, useContext } from "react";

/**
 * Sprint Y-CI fix : hook + context separes du composant Toast pour respecter
 * react-refresh/only-export-components (HMR fiabilite). Le ToastProvider reste
 * dans Toast.tsx.
 */

export type ToastKind = "success" | "error" | "info";

export interface ToastContextValue {
  show: (kind: ToastKind, message: string, opts?: { durationMs?: number }) => void;
  success: (message: string, opts?: { durationMs?: number }) => void;
  error: (message: string, opts?: { durationMs?: number }) => void;
  info: (message: string, opts?: { durationMs?: number }) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

/**
 * Hook : `const toast = useToast(); toast.success("...")`.
 * Errore si appele en dehors d'un ToastProvider (filet de securite).
 */
export function useToast(): ToastContextValue {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast doit etre utilise dans un <ToastProvider>");
  }
  return ctx;
}
